const visitorAppointment = {
  msg: {
    organization: '单位名称',
    enterOrganization: '请输入单位名称',
    appointmentInfo: '预约信息',
    campus: '园区',
    selectCampus: '请选择园区',
    visitReason: '访问事由',
    others: '其他',
    enterVisitReason: '请输入访问事由',
    personToVisit: '被访人',
    enterPersonToVisit: '请输入被访人',
    department: '部门',
    enterDepartment: '请选择部门',
    apptTime: '预约时间',
    selectApptTime: '请选择预约时间',
    vehicleInfo: '车辆信息',
    driving: '是否驾车',
    licensePlate: '车牌号',
    enterLicensePlate: '请输入车牌号',
    readAndAgree: '阅读并同意',
    safetyInstructions: '《欧莱雅入园安全须知》',
    submit: '提交',
    appointmentTimePicker: '预约时间',
    confirm: '确认',
    cancel: '取消',
    readCarefully: '请仔细阅读，',
    secondsRemaining: '秒后可勾选',
    readingComplete: '阅读完毕，请滚动到底部',
    readCheckAgreement: '已阅读，勾选同意',
    readingInProgress: '正在阅读，',
    beforeChecking: '秒后可勾选',
    submitting: '提交中...',
    loading: '加载中...',
    pleaseAgreeSafety: '请先阅读并同意入园安全须知',
    readingCompleteCanAgree: '阅读完毕，您可以勾选同意',
    pleaseReadSafety: '请先阅读安全须知',
    switchLang: 'English'
  }
};
export default visitorAppointment



// WEBPACK FOOTER //
// ./src/page/visitor/visitorAppointment/lang/visitorAppointment.zh.js